package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.repository.TeamRepository

class RemoveDriverUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(enterpriseId: String, driverId: String): Result<Unit> =
        repository.removeDriver(enterpriseId, driverId)
}
